import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '@/features/auth/hooks/useAuth'

interface NavItem {
  to: string
  label: string
  icon: string
}

const NAV_ITEMS: NavItem[] = [
  { to: '/admin', icon: '◼', label: 'Överblick' },
  { to: '/admin/photographers', icon: '👤', label: 'Zoomers' },
  { to: '/admin/missions', icon: '📍', label: 'Uppdrag' },
  { to: '/admin/images', icon: '🖼', label: 'Bildgranskning' },
  { to: '/admin/payouts', icon: '💸', label: 'Utbetalningar' },
  { to: '/admin/clients', icon: '🏢', label: 'Kunder' },
  { to: '/admin/submissions', icon: '📬', label: 'Inlämningar' },
]

export function AdminNav() {
  const { signOut } = useAuth()
  const navigate = useNavigate()

  const handleSignOut = async () => {
    await signOut()
    navigate('/auth')
  }

  return (
    <div className="flex flex-col h-full">
      {/* Logo */}
      <div className="px-5 py-5 border-b border-surface-border">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-brand-accent flex items-center justify-center">
            <span className="text-white text-xs font-bold">qZ</span>
          </div>
          <div>
            <p className="text-sm font-bold text-text-primary">quiXzoom</p>
            <p className="text-xs text-text-muted">Admin</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        {NAV_ITEMS.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/admin'}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-[120ms] ${
                isActive
                  ? 'bg-brand-accent/10 text-brand-accent'
                  : 'text-text-secondary hover:text-text-primary hover:bg-surface-overlay'
              }`
            }
          >
            <span className="text-base leading-none">{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>

      {/* Footer */}
      <div className="px-3 py-4 border-t border-surface-border">
        <button
          onClick={handleSignOut}
          className="flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm font-medium text-text-muted hover:text-brand-danger hover:bg-brand-danger/5 transition-all duration-[120ms]"
        >
          <span className="text-base leading-none">⎋</span>
          Logga ut
        </button>
      </div>
    </div>
  )
}
